export const Role = {
    space_admin: 'space_admin',
    participant: 'participant',
    booster: 'booster',
    guest: 'guest'
}